import { isReauthable, type ConnectorItem } from '@/api/connectors';

/** A bank-linked card's connection status (TMMAPP-0120 item 6), the `connection` status domain. */
export type ConnectionState = 'CONNECTED' | 'SYNCING' | 'NEEDS_ATTENTION';

/**
 * The card's one status for a connection, from what `GET /me/connectors` serves: Needs attention
 * when it must be reconnected (or the bank revoked it) or its first sync failed; Syncing while the
 * first sync is pending or running; Connected otherwise.
 */
export function connectionStateOf(item: ConnectorItem): ConnectionState {
  if (isReauthable(item.status) || item.status === 'REVOKED') return 'NEEDS_ATTENTION';
  const sync = item.initialSync?.state ?? null;
  if (sync === 'FAILED') return 'NEEDS_ATTENTION';
  if (sync === 'PENDING' || sync === 'RUNNING') return 'SYNCING';
  return 'CONNECTED';
}
